var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"expand-collapse",class:[{ expand: _vm.isExpand }, { 'overflow-visible': _vm.isExpanded }],style:([
    _vm.isExpand
      ? { height: _vm.baseHeight, transition: 'height 0.3s linear' }
      : { transition: 'height 0.3s linear' },
  ])},[_c('div',{ref:"expand",class:{'hidden-block': !_vm.showRef}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }